import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';

import { HarpValidators } from '@shared/utils/validators';
import { InputConfig } from '@shared/models/input-config.model';

import { CONFIG_MAP, SUBTOPICS, TOPICS } from './contact.constants';
import { ContactConfig } from './contact.types';

@Component({
  selector: 'app-contact',
  templateUrl: './contact.component.html',
  styleUrls: ['./contact.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class ContactComponent implements OnInit {
  contactForm: UntypedFormGroup;
  topicInput: InputConfig;
  subtopicInput: InputConfig;

  constructor(private fb: UntypedFormBuilder) {}

  ngOnInit(): void {
    this.initForm();
  }

  initForm() {
    this.contactForm = this.fb.group({
      topic: [, HarpValidators.required('')],
      subtopic: [, HarpValidators.required('')],
    });

    this.topicInput = {
      name: 'topic',
      type: 'select',
      form: this.contactForm,
      label: 'Choose a topic',
      required: true,
      options: TOPICS,
    };

    this.subtopicInput = {
      name: 'subtopic',
      type: 'select',
      form: this.contactForm,
      label: 'Choose a subtopic',
      required: true,
      disabled: true,
      options: [],
    };

    this.contactForm.controls['topic'].valueChanges.subscribe({
      next: topic => {
        this.subtopicInput.disabled = !topic;
        this.subtopicInput.options = SUBTOPICS[topic];
        this.contactForm.controls['subtopic'].reset();
      },
    });
  }

  get topic(): string {
    return this.contactForm.value.topic;
  }

  get subtopic(): string {
    return this.contactForm.value.subtopic;
  }

  get config() {
    return CONFIG_MAP?.[this.topic]?.[this.subtopic] as ContactConfig;
  }
}
